if (!customElements.get('nido-product-extras')) {
  customElements.define(
    'nido-product-extras',
    class NidoProductExtras extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-extra-card]'));
        this.button = this.querySelector('.nido-product-extras__button');
        this.status = this.querySelector('[data-extra-status]');

        this.cards.forEach((card) => {
          card.querySelector('[data-extra-checkbox]')?.addEventListener('change', () => this.updateSelection());
          card.querySelectorAll('[data-extra-variant-id]').forEach((button) => {
            button.addEventListener('click', () => this.selectVariant(card, button));
          });
        });

        this.button?.addEventListener('click', () => this.addSelected());
        this.updateSelection();
      }

      selectVariant(card, selectedButton) {
        card.querySelectorAll('[data-extra-variant-id]').forEach((button) => {
          const isSelected = button === selectedButton;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
        });

        const variantInput = card.querySelector('[data-extra-variant-input]');
        const price = card.querySelector('[data-extra-price]');
        const image = card.querySelector('.nido-product-extra__image');
        if (variantInput) variantInput.value = selectedButton.dataset.extraVariantId;
        if (price && selectedButton.dataset.extraVariantPrice) price.textContent = selectedButton.dataset.extraVariantPrice;
        if (image && selectedButton.dataset.extraVariantImage) image.src = selectedButton.dataset.extraVariantImage;
      }

      updateSelection(clearStatus = true) {
        let count = 0;
        this.cards.forEach((card) => {
          const checked = Boolean(card.querySelector('[data-extra-checkbox]')?.checked);
          card.classList.toggle('is-selected', checked);
          if (checked) count += 1;
        });

        if (this.button) this.button.disabled = count === 0;
        if (clearStatus && this.status) {
          this.status.textContent = '';
          this.status.classList.remove('is-error');
        }
      }

      async addSelected() {
        const items = this.cards
          .filter((card) => card.querySelector('[data-extra-checkbox]')?.checked)
          .map((card) => ({
            id: Number(card.querySelector('[data-extra-variant-input]')?.value),
            quantity: 1,
          }))
          .filter((item) => Number.isFinite(item.id) && item.id > 0);

        if (!items.length || !this.button || this.button.classList.contains('is-loading')) return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        if (cart?.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }

        this.button.classList.add('is-loading');
        this.button.disabled = true;
        if (this.status) this.status.textContent = 'Adicionando produtos…';

        try {
          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });
          const result = await response.json();

          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Não foi possível adicionar os produtos.');

          if (cart?.renderContents && result.sections) {
            if (!result.key && result.items?.length) result.key = result.items[0].key;
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } else {
            window.location.href = routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nido-product-extras', cartData: result });
          }

          this.cards.forEach((card) => {
            const checkbox = card.querySelector('[data-extra-checkbox]');
            if (checkbox) checkbox.checked = false;
          });
          this.updateSelection(false);
          if (this.status) this.status.textContent = 'Produtos adicionados ao carrinho.';
        } catch (error) {
          if (this.status) {
            this.status.textContent = error.message;
            this.status.classList.add('is-error');
          }
        } finally {
          this.button.classList.remove('is-loading');
          this.updateSelection(false);
        }
      }
    }
  );
}
